import React, { useEffect } from 'react';
import StyledFilterItemWrapper from '../../../../../../style/Common/Filter/Modal/Content/Item/StyledFilterItemWrapper';

const FilterItem = ({ ...props }) => {
  const { label, style, onClick, isSelected } = props;

  return (
    <StyledFilterItemWrapper
      $style={style}
      onClick={onClick}
      isSelected={isSelected}
    >
      {label || '-'}
    </StyledFilterItemWrapper>
  );
};

export default FilterItem;
